import React from 'react'
import { DatePicker, Select, Space } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/es'
import locale from 'antd/es/date-picker/locale/es_ES'
import { TModuleOptions } from '../../../../models/storageModel'

const { RangePicker } = DatePicker

interface InventoryReportFiltersProps {
  dateRange: [Dayjs, Dayjs]
  onDateChange: (dates: [Dayjs, Dayjs]) => void
  registerTypeFilter: string
  onRegisterTypeChange: (val: string) => void
  categoryFilter: string
  onCategoryChange: (val: string) => void
  storehouseFilter: string
  onStorehouseChange: (val: string) => void
  categoryOptions: TModuleOptions[]
  storehouses: any[]
  loading?: boolean
}

const presetRanges: Record<string, [Dayjs, Dayjs]> = {
  'Últimos 30 días': [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')],
  'Este Mes': [dayjs().startOf('month'), dayjs().endOf('month')],
  'Mes Anterior': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
  'Últimos 90 días': [dayjs().subtract(89, 'day').startOf('day'), dayjs().endOf('day')],
  'Este Año': [dayjs().startOf('year'), dayjs().endOf('year')]
}

export const InventoryReportFilters: React.FC<InventoryReportFiltersProps> = ({
  dateRange,
  onDateChange,
  registerTypeFilter,
  onRegisterTypeChange,
  categoryFilter,
  onCategoryChange,
  storehouseFilter,
  onStorehouseChange,
  categoryOptions,
  storehouses,
  loading = false
}) => {
  const handleDateChange = (dates: any) => {
    if (dates && dates[0] && dates[1]) {
      onDateChange([dates[0].startOf('day'), dates[1].endOf('day')])
    }
  }

  const rangePresets = Object.keys(presetRanges).map(label => ({
    label,
    value: presetRanges[label]
  }))

  return (
    <Space wrap size="middle">
      <div>
        <label style={{ fontWeight: 500, marginRight: 8, color: '#555' }}>Período Análisis:</label>
        <RangePicker
          locale={locale}
          value={dateRange}
          onChange={handleDateChange}
          presets={rangePresets}
          format="DD/MM/YYYY"
          disabled={loading}
          allowClear={false}
          style={{ width: 270 }}
        />
      </div>

      <div>
        <label style={{ fontWeight: 500, marginRight: 8, color: '#555' }}>Tipo Elemento:</label>
        <Select
          value={registerTypeFilter}
          onChange={onRegisterTypeChange}
          disabled={loading}
          style={{ width: 170 }}
          options={[
            { value: 'ALL', label: 'Todos los tipos' },
            { value: 'PRODUCT', label: '📦 Productos' },
            { value: 'SERVICE', label: '🛠️ Servicios' }
          ]}
        />
      </div>

      <div>
        <label style={{ fontWeight: 500, marginRight: 8, color: '#555' }}>Categoría:</label>
        <Select
          value={categoryFilter}
          onChange={onCategoryChange}
          disabled={loading}
          style={{ width: 190 }}
          options={[
            { value: 'ALL', label: 'Todas las categorías' },
            ...categoryOptions.map(cat => ({
              value: cat.key,
              label: cat.string_value || cat.key
            }))
          ]}
        />
      </div>

      <div>
        <label style={{ fontWeight: 500, marginRight: 8, color: '#555' }}>Almacén:</label>
        <Select
          value={storehouseFilter}
          onChange={onStorehouseChange}
          disabled={loading}
          style={{ width: 190 }}
          options={[
            { value: 'ALL', label: 'Todos los almacenes' },
            ...storehouses.map(st => ({
              value: st.uid || String(st.id),
              label: st.name || st.alias || `Almacén #${st.id}`
            }))
          ]}
        />
      </div>
    </Space>
  )
}

export default InventoryReportFilters
